import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';
import {PAGINACAO_PADRAO} from '../../components/paginacao.js';
import {
    comChaveFalhas,
    resumoResultadoEnvio,
    TITULO_RESULTADO_ENVIO
} from '../../components/recursos/envioEmails.js';

const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    root: {
        width: 800,
        maxWidth: '100%'
    },
    contentRoot: {overflowY: 'initial'},
    resumo: {marginBottom: theme.spacing(2)}
}));

/* Resultado do envio com falhas: quantos e-mails saíram e quais inscritos falharam (com o motivo). */
export default function DialogResultadoEnvioEmails(props) {
    const {open, onClose, enviados = 0, falhas = []} = props;
    const classes = useStyles();
    const linhas = useMemo(() => comChaveFalhas(falhas), [falhas]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            scroll='body'
            classes={{paper: classes.root}}
            aria-labelledby='dialog-resultado-envio-emails-titulo'>
            <DialogTitle id='dialog-resultado-envio-emails-titulo'>{TITULO_RESULTADO_ENVIO}</DialogTitle>
            <DialogContent classes={{root: classes.contentRoot}}>
                <Typography variant='body1' className={classes.resumo}>
                    {resumoResultadoEnvio(enviados, linhas.length)}
                </Typography>
                <DataGrid
                    rows={linhas}
                    comparatorKeys={['chave']}
                    paginate
                    paginateOptions={PAGINACAO_PADRAO}
                    tableContainerProps={TABLE_CONTAINER_PROPS}
                    noRecordsText='Nenhuma falha.'
                    columns={[
                        {label: 'Nome', field: 'nome', filterable: false, valueGetter: valor => ouTraco(valor)},
                        {label: 'Motivo', field: 'motivo', filterable: false, valueGetter: valor => ouTraco(valor)}
                    ]}/>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
            </DialogActions>
        </Dialog>
    );
}

DialogResultadoEnvioEmails.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    /* Quantidade de e-mails enviados. */
    enviados: PropTypes.number,
    /* Falhas: [{idInscricao, nome, motivo}]. */
    falhas: PropTypes.array
};
